import React, { Component, useEffect, useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next'
import LoginView from './LoginView';
import OtpView from './OtpView';
import Loading from '../../components/Loading';
import ModalAlert from '../../components/ModalAlert';
import crmServices from '../../wsclient/crmservices'
import t from '../../utils/translateUtil';
import { startCountDown } from "../../utils/util";
import {getAppCfg,getBrowser, getSupportOrderLocation, getRejectTriggerContact, setSupportOrderContact, getCountries, getCountryDefault} from '../../utils/common'
import { connection, domainName, portal_config } from '../../../portal.config';
import { paths, portalCfg } from '../../../portal.router.config';
import ModalConfirm from '../../components/ModalConfirm';
import { CyprusFlagIcon } from '../../components/icons';
import { dataUtil } from '../../wsclient/crmservices/dataUtil';

const styles = theme => ({

});
function Login(props){
    let app_config = getAppCfg();
    let agreement_countries = app_config && app_config.contact && app_config.contact.agreement_countries ? app_config.contact.agreement_countries : null
    let country_default = getCountryDefault(agreement_countries);


    const [active, setActive] = useState('main');
    const [auth_otp, setAuthOtp] = useState(null);
    const [obfuscatedValue, setObfuscatedValue] = useState(null);
    const [showLoading, onShowLoading] = useState(false);
    const [phone_number, setPhoneNumber] = useState('');
    const [timer_otp, setTimeOTP] = useState(null);
    const [countDown, setCountDown] = useState(null);
    const [error, setError] = useState({
                                        showAlert: false,
                                        title: '',
                                        message: '',
                                        status: '',
                                    })
    const [confirm, setConfirm] = useState({});
    const [country_select, onSelectCountry] = useState(country_default);
    const auth_support = app_config && app_config.auth_support ? app_config.auth_support: {facebook:false, google:false};
    const requestTimer = 30;

    const showAlert = (status, message, title)=> {
        onShowLoading(false);
        setError({            
                    showAlert: true,
                    title: title,
                    message: message,
                    status: status,
                });
    }
    const onCloseAlert = ()=> {
        onShowLoading(false);
        setError({            
                    showAlert: false,
                    title: '',
                    message: '',
                    status: '',
                });
    }

    const onSendOTP = async(values)=> {
        onShowLoading(true);
        setPhoneNumber(values.phone);
        const config = getAppCfg();
        const application_id = config && config.id ? config.id : null;
        try {
            //let result = await crmServices.contacts.sendCredentialsOTP({send_method: 'SMS', name: 'PHONE', value: values.phone});            
            let result = await crmServices.contacts.authenticatePhone({phone_number: values.phone, country_code: country_select.value, application_id: application_id});
            if (result.code === 'OK') {
                if (result.data && result.data.auth_otp) {
                    setObfuscatedValue(result.data.obfuscated_value);
                    setAuthOtp(result.data.auth_otp);
                }
                onShowLoading(false);
                setActive('verify');
                beginCountDown();
            } else {
                showAlert("ERROR", t('INVALID_PHONE_LOGIN'),  t('ERROR'));
            }
        } catch (error) {
            showAlert("ERROR", t('EXCEPTION_PROCESS'));
        }
        onShowLoading(false);
    }
    const onLogin = async(values)=> {
        onShowLoading(true);
        try {
            const config = getAppCfg();
            let verifyOtp = await crmServices.contacts.validateOTP({ phone: phone_number, auth_otp: auth_otp, otp: values.otp_code });
            if (verifyOtp.code === "OK") {
                //crmServices.contacts.addApplicationUsage(config.id,getBrowser().toUpperCase());
                onShowLoading(false);
                if(!getSupportOrderLocation()&&!getRejectTriggerContact()){
                    var ordering_countries = []
                    if(config.features && config.features.ordering&&config.features.ordering_details&&config.features.ordering_details.ordering_countries){
                        ordering_countries = config.features.ordering_details.ordering_countries
                    }
                    var isAllowOrder = await dataUtil.checkAllowOrderByContact(ordering_countries);
                    if(isAllowOrder){
                        setSupportOrderContact(true)
                    }
                }

                props.history.push('/home');
            } else {
                showAlert("ERROR", t('INVALID_OTP'), t('OTP'));
            }
            onShowLoading(false);
        } catch (error) {
            console.log("error:", error);
            showAlert("ERROR", t('EXCEPTION_PROCESS'), t('OTP'));
        }
    }
    const onResendCode = async ()=> {
        onShowLoading(true);
        const config = getAppCfg();
        const application_id = config && config.id ? config.id : null;
        try {
            // let result = await crmServices.contacts.sendSMSOTP(phone_number);
            let result = await crmServices.contacts.authenticatePhone({phone_number: phone_number, country_code: country_select.value, application_id: application_id});
            //console.log("AAAAAAA result:",result);
            if (result.code === 'OK') {
                if (result.data && result.data.auth_otp) {
                    setAuthOtp(result.data.auth_otp);
                }
                showAlert('SUCCESS', t('OTP_RESEND_SUCCESS'), t('OTP'))
                beginCountDown();
            } else if(result.code=='TOO_MANY_REQUESTS'){
                showAlert(t('ERROR'), t('TOO_MANY_REQUESTS'));
            } else if(result.code=='TOO_MANY_RECIPIENTS_EXCEPTION'){
                showAlert(t('ERROR'), t('TOO_MANY_RECIPIENTS_EXCEPTION'));
            } else {
                showAlert('ERROR', t('EXCEPTION_PROCESS'), t('OTP'))
            }
        } catch (error) {
            console.log('onResendCode error:', error)
            showAlert('ERROR', t('EXCEPTION_PROCESS'), t('OTP'))
        }
        onShowLoading(false);
    }
    const beginCountDown = async()=>{
        let timerOTP = {
            interval: 1000, //in millisecond - 1 second 
            decreaseVal: 1,
            intervalInstance: undefined
        };
        console.log('Count down timer ', requestTimer);
        timerOTP.fromVal = Number(requestTimer);

        startCountDown(timerOTP, setCountDown, timer_otp);
        setCountDown(timerOTP.fromVal)
        setTimeOTP(timerOTP);
    }


    const onRegister = ()=> {
        // if(portal_config[domainName].isCredentials)
        //     this.showConfirm(true, t('exits_rewards_participant'));
        // else
            props.history.push(paths.register);
    }
    const onYesExistRewards = ()=>{
        props.history.push(paths.identify);
        showConfirm(false)
    }
    const onNoExistRewards = ()=>{
        props.history.push(paths.register);
        showConfirm(false)
    }
    const showConfirm = (status, message)=> {
        onShowLoading(false);
        setConfirm({
                    show: status,
                    content: message ? message : null}
                    );
    }
    const renderPage = (active) => {
        if (active === 'main') {
            return <LoginView
                onSendOTP={onSendOTP}
                showAlert = {showAlert}
                onShowLoading = {onShowLoading}
                country_select={country_select}
                onSelectCountry={onSelectCountry}
                auth_support={auth_support}
                onRegister = {onRegister}
                agreement_countries={agreement_countries}
            />
        }
        else if (active === 'verify') {
            return <OtpView
                onLogin={onLogin}
                onResend={onResendCode}
                countDown={countDown}
                obfuscatedValue={obfuscatedValue}
            />
        }
    }
    const page = renderPage(active);
    return(
            <div>       
                {page}
                <Loading showLoading={showLoading} />
                {confirm && <ModalConfirm
                    open={confirm.show}
                    onClose={onNoExistRewards}
                    message={confirm.content}
                    confirm={t('yes')}
                    buttonLabel={t('no')}
                    onAction={onYesExistRewards}
                    />}
                <ModalAlert
                    open={error.showAlert}
                    onClose={onCloseAlert}
                    hideHeader={true}
                    message={error.message}
                    error={error.status}
                    title={error.title}
                />
            </div>
    )
}
export default withStyles(styles)(withTranslation()(Login));